import { Lock } from 'lucide-preact'

interface CrmSlotTakenNoticeProps {
    headline: string
    detail: string
}

/**
 * Stands in for a connect view when another CRM already holds the company's slot. Reached from the
 * Available grid and, more often, from a previously-disconnected CRM's card, which keeps a Manage
 * entry point long after it stops appearing as connectable.
 */
export function CrmSlotTakenNotice({ headline, detail }: CrmSlotTakenNoticeProps) {
    return (
        <div className="max-w-md mx-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 px-6 py-5 space-y-2">
            <p className="flex items-center gap-2 text-sm font-medium text-slate-900 dark:text-white">
                <Lock className="w-4 h-4 shrink-0 text-slate-400 dark:text-slate-500" />
                {headline}
            </p>
            <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-400">{detail}</p>
        </div>
    )
}
